export interface BrandInfoListItem {
  /** 品牌名称 */
  brandName?: string;
  /** 品牌id */
  brandId?: number;
}

export enum ResourceCodeEnums {
  /** 人群资产分析 */
  INSIGHT = "insight",
  /** 人群流转 */
  CROWD_TRANS = "crowd_trans",
  /** 人群分布 */
  CROWD_DISTRIBUTE = "crowd_distribute",
  /** 人群透视 */
  CROWD_PERSPECTIVE = "crowd_perspective",
  /** 店铺人群洞察 */
  MALL_CROWD_DISTRIBUTE = "mall_crowd_distribute",
  /** 商品人群洞察 */
  GOODS_CROWD_DISTRIBUTE = "goods_crowd_distribute",
  /** 高级分析 */
  RFM = "rfm",
  /** 人群追踪 */
  CROWD_TRACE = "crowd_trace",
  /** 人群资产管理 */
  CROWD_MANAGEMENT = "crowd_management",
  /** 自定义人群 */
  CUSTOM_LABEL = "custom_label",
  /** 授权人群 */
  AUTH_LABEL = "auth_label",
  /** 旗下店铺人群 */
  MALL_LABEL = "mall_label",
  /** 官方人群 */
  OFFICIAL_LABEL = "official_label",
  /** 人群广场 */
  LABEL_SQUARE = "label_square",

  /** 生意数据 */
  BUSINESS_DATA = "brand_gmv",
  /** 交易数据 */
  GMV_OVERVIEW = "gmv_overview",
  /** 交易构成 */
  GMV_DETAIL = "gmv_detail",
  /** 商品监控 */
  GOODS_MONITOR = "goods_monitor",

  /** 推广平台 */
  PROMOTION_EFFECT = "promotion_effect",
  /** 推广花费 */
  MARKETING_DATA = "marketing_data",
  /** 品牌推广(投放数据) */
  BRAND_DATA = "brand_data",
  /** 人群推广效果
   * @deprecated
   */
  CROWD_PROMOTION_EFFECT = "crowd_promotion_effect",
  /** 活动推广效果
   * @deprecated
   */
  ACTIVITY_PROMOTION_EFFECT = "activity_promotion_effect",
  /** 跟踪报告 (下线停用)
   * @deprecated
   */
  TRACKING_REPORT = "tracking_report",
  /** 拉新分析 */
  RCT_ANALYSIS = "rct_analysis",
  /** 投放追踪 */
  PROMO_TRACE = "promo_trace",

  /** 下载中心 */
  DOWNLOAD_CENTER = "download_center",
  /** 人群预估工具 */
  IMPR_EVAL = "impr_eval",
  /** 操作记录 */
  OPERATION_LOG = "operation_log",

  /** 授权管理(账号授权) */
  ACCOUNT_AUTH = "account_auth",
  /** 子账号管理 */
  SUB_ACCOUNT_MANAGEMENT = "sub_account_management",

  /** 搜索流量分析 */
  FLOW_ANALYSIS = "flow_analysis",
  /** 品牌榜单 */
  BRAND_RANK = "brand_rank",
  /** 行业趋势 */
  INDUSTRY_TREND = "industry_trend",
  /** 市场渗透率 */
  MARKET_PENETRATION = "market_penetration",
  /** 品牌热度指数 */
  BRAND_HEAT_INDEX = "brand_heat_index",
  /** 人群关联洞察 */
  CROWD_RELEVANCE = "crowd_relevance",

  /** 新建人群包 */
  CREATE_CROWD = "create_crowd",
  /** 按标签圈选新建 */
  CUSTOM_LABEL_CREATE = "custom_label_create",
  /** 上传人群包 */
  UPLOAD_CREATE = "upload_create",
  /** 智能圈选 */
  MODEL_CREATE = "model_create",
  /** 按标签圈选新建 - 标签 */
  FROM_CUSTOM_LABEL = "from_custom_label",
  /** 按标签圈选新建 - 已有人群 */
  FROM_EXIST_LABEL = "from_exist_label",
  /**
   * 按标签圈选新建 - 暂存人群
   * @notice 这个只判断创建人群页面是否有暂存人群
   */
  FROM_PACK_LABEL = "from_pack_label",
  /** 人群画像对比 */
  PORTRAIT_DIFF = "portrait_diff",

  /** 首页 */
  HOME = "home",

  /** ----- 下面所有的code后端没有 ----- */

  /** 服务协议 */
  AGREEMENT = "agreement",
  /** --- 下面这些对应前端pages下的route, 不对应具体的功能模块 --- */
  /** 人群资产 */
  CROWD = "crowd",
  /** 生意 */
  BUSINESS = "business",
  /** 活动推广 */
  ACTIVITY_PROMOTION = "activity_promotion",
  /** 市场洞察 */
  MARKET_INSIGHT = "market_insight",
  /** 工具 */
  TOOL = "tool",
  /** 账号管理 */
  ACCOUNT_MANAGEMENT = "account_management",
}

export interface QueryAuthCateInfoParam {
  /** 是否展示全部类目 */
  showAllCates?: boolean;
}

export interface AuthCate2InfoListItem {
  /** 一级类目id */
  cate1Id?: number;
  /** 二级类目名称 */
  cate2Name?: string;
  /** 一级类目id */
  cate1Name?: string;
  /** 二级类目id */
  cate2Id?: number;
}
export interface QueryAuthCateInfoResult {
  /** 店铺所有有权限类目 */
  authCate2InfoList?: Array<AuthCate2InfoListItem>;
}
export type QueryUserTypeAndInfoParams = object;
export interface BrandInfoListItem {
  /** 品牌名称 */
  brandName?: string;
  /** 品牌id */
  brandId?: number;
}
export interface QueryUserTypeAndInfoResult {
  /** 用户头像url */
  userPicUrl?: string;
  /** 用户id */
  uid?: number;
  /** 账户类型：10 -> 品牌超级账号, 20 -> 超星星店铺, 30 -> 普通店铺账号 */
  userType?: number;
  /** 店铺id */
  mallId?: number;
  /** 有权限访问的资源模块. 可选值含义说明:[home:首页;create_crowd:创建人群包方式;custom_label_create:按标签圈选新建;from_custom_label:标签;from_exist_label:已有人群;from_pack_label:暂存人群;upload_create:按标签圈选新建;model_create:智能圈选新建;crowd:人群资产;insight:人群资产分析;crowd_trans:人群流转;crowd_distribute:人群分布;crowd_perspective:人群透视;mall_crowd_distribute:店铺洞察;goods_crowd_distribute:商品洞察;rfm:高级分析;crowd_management:人群资产管理;custom_label:自定义人群;portrait_diff:人群画像对比;auth_label:授权人群;mall_label:旗下店铺人群;official_label:官方人群;business:生意;brand_gmv:生意数据;gmv_overview:交易数据;gmv_detail:交易构成;goods:商品;goods_monitor:商品监控;activity_promotion:活动推广;promotion_effect:推广平台;marketing_data:推广花费;brand_data:推广数据;promo_trace:推广追踪报告;market_insight:市场洞察;search_analysis:搜索分析;flow_analysis:搜索流量分析;market_rank:市场洞察;brand_rank:品牌榜单;industry_trend:行业趋势;brand_heat_index:品牌热度指数;tool:工具;download_center:下载中心;operation_log:操作记录;impr_eval:人群预估工具;account_management:账号管理;account_auth:授权管理;sub_account_management:子账号管理;]
   * @deprecated 请使用 resourceAuthList
   */
  resourceCodeList?: Array<ResourceCodeEnums>;
  /** 品牌或店铺的名称（账号区显示） */
  name?: string;
  /** 需要展示的资源模块. 可选值含义说明:[home:首页;create_crowd:创建人群包方式;custom_label_create:按标签圈选新建;from_custom_label:标签;from_exist_label:已有人群;from_pack_label:暂存人群;upload_create:按标签圈选新建;model_create:智能圈选新建;crowd:人群资产;insight:人群资产分析;crowd_trans:人群流转;crowd_distribute:人群分布;crowd_perspective:人群透视;mall_crowd_distribute:店铺洞察;goods_crowd_distribute:商品洞察;rfm:高级分析;crowd_management:人群资产管理;custom_label:自定义人群;portrait_diff:人群画像对比;auth_label:授权人群;mall_label:旗下店铺人群;official_label:官方人群;business:生意;brand_gmv:生意数据;gmv_overview:交易数据;gmv_detail:交易构成;goods:商品;goods_monitor:商品监控;activity_promotion:活动推广;promotion_effect:推广平台;marketing_data:推广花费;brand_data:推广数据;promo_trace:推广追踪报告;market_insight:市场洞察;search_analysis:搜索分析;flow_analysis:搜索流量分析;market_rank:市场洞察;brand_rank:品牌榜单;industry_trend:行业趋势;brand_heat_index:品牌热度指数;tool:工具;download_center:下载中心;operation_log:操作记录;impr_eval:人群预估工具;account_management:账号管理;account_auth:授权管理;sub_account_management:子账号管理;]
   * @deprecated 请使用 resourceAuthList
   */
  showResourceCodeList?: Array<ResourceCodeEnums>;
  /** 主账号账号名称 */
  mallOwnerUsername?: string;
  /** 是否为主账号 */
  mallOwner?: boolean;
  /** 可选品牌列表 */
  brandInfoList?: Array<BrandInfoListItem>;
  /** 账号名称 */
  username?: string;
  /** 是否达到30天6000元开通门槛 */
  reachNormalCondition?: boolean;
  resourceAuthList?: ResourceAuth[];
  /** 是否有DMP权限 */
  hasDmpAuth?: boolean;
  /** 无权限时的解锁文案 */
  noAuthMsg?: string;
}

export interface ResourceAuth {
  /** 资源模块 */
  resourceCode?: ResourceCodeEnums;
  /** 是否有访问权限: 1-有权限, 其他情况无权限 */
  authType?: AuthTypeEnums | number;
  /** 无权限时的解锁文案 */
  noAuthMsg?: string;
}

export enum AuthTypeEnums {
  HAS = 1,
}

export enum UserTypeEnum {
  /** 初始化 */
  INIT = 0,
  /** 品牌版 */
  BRAND = 10,
  /** 星店版 */
  SUPER = 20,
  /** 普通版 */
  NORMAL = 30,
  /** 高级版 */
  ADVANCED = 40,
  /** 中级版 */
  MIDDLE = 50,
}

export interface QueryAuthBrandInfoParams {
  /** 授权品牌名称 */
  brandName?: string;
}

export interface AuthBrandInfoListItem {
  /** 店铺id */
  brandId?: number;
  /** 店铺名称 */
  brandName?: string;
}
export interface QueryAuthBrandInfoResult {
  /** 已授权店铺 */
  authBrandInfoList?: Array<AuthBrandInfoListItem>;
}
